<div class="page-title">
  <h1><mat-icon color="primary">home</mat-icon>&nbsp;Accueil</h1>
</div>

<div class="row-page-content">
  <div class="page-content">

    <div class="section-container">
      <div class="section section-decoration section-welcome">
        Bonjour et bienvenue sur KLAFUTI.<br />
        <br />
        Vous pouvez accéder à nos différents outils via le menu latéral.
      </div>
      <div class="section section-decoration section-appointment">
        Vous êtes client Axonaut ?<br />
        <br />
        <span>Prenez rendez-vous <a class="calendar-link" href={{calendarUrl}}>ici</a> pour un tutoriel
          personnalisé</span>
      </div>

      <div class="section section-decoration section-support">
        Pour toute question concernant l'application, veuillez contacter le support&nbsp;à&nbsp;:<br />
        <br />
        <a href="mailto:{{supportEmail}}">{{supportEmail}}</a>
      </div>
    </div>


    <h2>Mes connecteurs</h2>
    <button mat-raised-button color="primary" (click)="openDialog()"><mat-icon>add</mat-icon>Ajouter un
      connecteur</button>
    <ng-container *ngIf="connectors$ | async as connectors else loading">
      <div class="list mosaic" *ngIf="connectors$ | async as connectors; else loading">
        <p>Nombre de connecteurs &nbsp;: {{connectors.length}}</p>

        <a [routerLink]="['../', 'folders', connector.folder?.id, 'connectors', connector.id ]" class="list-item connector-item" *ngFor="let connector of connectors">
          <div>
            <span><strong>{{connector.label}}</strong></span>
            <br />
            <span>({{connector.folder?.label}})</span>
          </div>

          <div class="list-item_inner-right">
            <mat-icon>arrow_right_alt</mat-icon>
          </div>
        </a>
      </div>
    </ng-container>
  </div>
</div>




<ng-template #loading>
  <div class="loading-wrapper">
    <mat-spinner color="accent" diameter="50"></mat-spinner>
  </div>
</ng-template>